import { cached } from 'Utility/async';

export enum FarmSlotType {
    SMALL = 'small',
    BIG = 'big',
    CROP = 'crop',
    FENCE = 'fence',
    HOUSE = 'house',
}

export const CACHED_FARM_SLOT_TYPE = cached<FarmSlotType[]>(() => {
    return Object.values(FarmSlotType);
});

export function isFarmSlotType(value: unknown): value is FarmSlotType {
    return CACHED_FARM_SLOT_TYPE().includes(value as FarmSlotType);
}
